import { useTheme } from '@emotion/react'
import { AppState, getSectionMetaInfo } from '@news-mono/web-common'
import { useSelector } from 'react-redux'

export function useSectionMetaInfo() {
    const theme = useTheme()
    const sectionMeta = useSelector((state: AppState) => state.meta.sectionMeta)
    return getSectionMetaInfo(sectionMeta, theme.section)
}
